export const NATIONALITY_MAX_LENGTH = 2;
export const NATIONALITY_REGEXP = /^[A-Za-z]{0,2}$/m;

export const validationNationalityRules = {
  pattern: {
    value: NATIONALITY_REGEXP,
    message: 'validation.onlyCapitalLetters'
  },
  maxLength: {
    value: NATIONALITY_MAX_LENGTH,
    message: 'validation.valueLongerThan2'
  }
};
